<template>
  <div class="function-nav" >
    <!-- 顶部按钮区域 -->
    <div class="top-section" v-if="show">
      <!-- 左侧长方形按钮 -->
      <div class="left-column">
        <FunctionButton
          v-for="item in leftButtons"
          :key="item.title"
          :title="item.title"
          :icon="item.icon"
          :to="item.to"
          :is-rectangle="true"
          :is-left-column="true"
          :height="'115px'"
          @click.native="handleButtonClick(item.action)"
        />
      </div>

      <!-- 右侧正方形按钮 -->
      <div class="right-column">
        <FunctionButton
          v-for="item in rightButtons"
          :key="item.title"
          :title="item.title"
          :icon="item.icon"
          :to="item.to"
          :is-left-column="false"
          @click.native="handleButtonClick(item)"
        />
      </div>
    </div>

    <!-- 三个图片按钮 -->
    <div class="image-buttons">
      <div
        v-for="(item, index) in imageButtons"
        :key="index"
        class="image-button"
        @click="handleButtonClick(item.action)"
      >
        <img :src="item.icon" :alt="item.title">
      </div>
    </div>

    <!-- 计划选择的动作面板 -->
    <van-action-sheet
      v-model="showPlanActionSheet"
      :actions="planOptions"
      cancel-text="取消"
      close-icon-position="top-right"
      @select="onSelectPlan"
    />
  </div>
</template>

<script>
import FunctionButton from './FunctionButton.vue'

export default {
  name: 'FunctionNavDayunshan',
  components: {
    FunctionButton
  },
  props: {
    /**
     * 控制组件显示与隐藏，父组件可通过 :show="false" 隐藏本组件
     * 默认为 true
     */
    show: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      // 左侧按钮配置
      leftButtons: [
        {
          title: '种植基地直播',
          icon: 'https://cdn.keihong.tech/img/20250421190937594.png',
          to: '',
          action: 'tapLive'
        },
        {
          title: '荞麦的功效',
          icon: 'https://cdn.keihong.tech/img/20250421190947440.png',
          to: '',
          action: 'tapShortVideo'
        }
      ],
      // 右侧按钮配置
      rightButtons: [
        {
          title: '糖尿病知识',
          icon: 'https://cdn.keihong.tech/img/20250421185616892.png',
          to: '/dayunshan/ArticlesSick/diabetes',
          action: 'devClick'
        },
        {
          title: '高血脂知识',
          icon: 'https://cdn.keihong.tech/img/20250421185427102.png',
          to: '/dayunshan/ArticlesSick/hyperlipidemia',
          action: 'devClick'
        },
        {
          title: '高血压知识',
          icon: 'https://cdn.keihong.tech/img/20250421185523475.png',
          to: '/dayunshan/ArticlesSick/hypertension',
          action: 'devClick'
        }
      ],
      // 图片按钮配置
      imageButtons: [
        // {
        //   title: '合作医院',
        //   icon: 'https://cdn.keihong.tech/img/20250421193519977.png',
        //   action: 'tapImageButton1'
        // },
        {
          title: '合作机构',
          icon: 'https://cdn.keihong.tech/img/20250524112057819.png',
          action: 'tapImageButton2'
        },
        {
          title: '合作专家',
          icon: 'https://cdn.keihong.tech/img/20250524112210109.png',
          action: 'tapImageButton3'
        }
      ],
      // 选择框选项
      planOptions: [
        { name: '我的训练方案', value: 'my-plan' },
        { name: '公众号推荐合集', value: 'recommend' },
        { name: '社区课程', value: 'community' }
      ],
      showPlanActionSheet: false
    }
  },
  methods: {
    handleButtonClick (actionOrItem) {
      // 兼容原有调用方式，支持传入item对象或action字符串
      let action = actionOrItem
      let to = ''
      if (typeof actionOrItem === 'object') {
        action = actionOrItem.action
        to = actionOrItem.to
      }
      // 优先处理to跳转
      if (to) {
        this.$router.push(to)
        return
      }
      // 调用父组件的方法
      if (this.$parent[action]) {
        this.$parent[action]()
      } else {
        switch (action) {
          case 'tapShortVideo':
            this.$router.push({
              path: '/shortVideo'
            })
            break
          case 'tapImageButton1':
            this.$router.push({
              path: '/article/detail',
              query: { id: '101' }
            })
            break
          case 'tapImageButton2':
            this.$router.push({
              path: '/article/detail',
              query: { id: 'dayunshan_201' }
            })
            break
          case 'tapImageButton3':
            this.$router.push({
              path: '/article/detail',
              query: { id: 'dayunshan_202' }
            })
            break
          case 'tapSleepPlan':
            this.$router.push({
              path: '/article/detail',
              query: { id: '201' }
            })
            break
          case 'tapNutritionPlan':
            this.$router.push({
              path: '/article/detail',
              query: { id: '202' }
            })
            break
          case 'tapPsychologyPlan':
            this.$router.push({
              path: '/article/detail',
              query: { id: '203' }
            })
            break
          case 'tapLive': {
            console.log('tapLive')
            // 跳转小程序直播页面
            const isLogin = this.$store.state.user.profile.isLogin
            if (isLogin) {
              if (window.wx?.miniProgram) {
                console.log('window.wx.miniProgram', window.wx.miniProgram)
                const hospitalId = this.$store.state.user.qrCodeHospitalId || ''
                console.log('hospitalId', hospitalId)
                window.wx.miniProgram.navigateTo({
                  url: `/pages/live/live?from=web&phone=${this.$store.state.user.profile.phone}&hospitalId=${hospitalId}`
                })
              } else {
                // toast 请在小程序中打开
                this.$toast({
                  message: '请在小程序中打开',
                  position: 'middle',
                  duration: 2000
                })
              }
            } else {
              this.$router.push('/login/index')
            }
            break
          }
          case 'tapPlanSelect': {
            console.log('tapPlanSelect')
            // 显示计划选择动作面板
            this.showPlanActionSheet = true
            break
          }
          case 'community':
            // 跳转小程序社区课程页面
            if (window.wx?.miniProgram) {
              const hospitalId = this.$store.state.user.qrCodeHospitalId || ''
              window.wx.miniProgram.navigateTo({
                url: `/pages/community/index?from=web&phone=${this.$store.state.user.profile.phone}&hospitalId=${hospitalId}`
              })
            } else {
              this.$toast({
                message: '请在小程序中打开',
                position: 'middle',
                duration: 2000
              })
            }
            break
          case 'devClick':
            this.$toast({
              message: '内容正在建设中，敬请期待',
              position: 'middle',
              duration: 2000
            })
            break
          default:
            this.$toast({
              message: '功能正在开发中，敬请期待',
              position: 'middle',
              duration: 2000
            })
            break
        }
      }
    },

    // 处理计划选项选择
    onSelectPlan (action) {
      // 根据选择的选项进行相应的路由跳转
      switch (action.value) {
        case 'my-plan':
          this.$parent.tapPlan()
          break
        case 'recommend':
          this.$router.push('/planListPage?phone=' + '19910010001')
          break
        case 'community':
          // 跳转小程序社区课程页面
          if (window.wx?.miniProgram) {
            const hospitalId = this.$store.state.user.qrCodeHospitalId || ''
            window.wx.miniProgram.navigateTo({
              url: `/pages/community/index?from=web&phone=${this.$store.state.user.profile.phone}&hospitalId=${hospitalId}`
            })
          } else {
            this.$toast({
              message: '请在小程序中打开',
              position: 'middle',
              duration: 2000
            })
          }
          break
        default:
          break
      }
    }
  }
}
</script>

<style scoped>
.function-nav {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  padding: 16px;
  box-sizing: border-box;
}

.top-section {
  display: flex;
  gap: 8px;
  width: 100%;
}

.left-column {
  flex: 7.6;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.right-column {
  flex: 11.1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

/* 确保左右两栏高度一致 */
.left-column, .right-column {
  height: 270px; /* 5个右侧按钮 × 84px 高度 */
}

/* 三个图片按钮容器 */
.image-buttons {
  display: flex;
  width: 100%;
  gap: 8px;
  margin-top: 8px;
}

/* 单个图片按钮 */
.image-button {
  flex: 1;
  overflow: hidden;
  border-radius: 8px;
  background-color: #f5f5f5;
  cursor: pointer;
}

.image-button img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
